import type React from 'react'
import { CHECKOUT_URL } from '../data/checkout'
import { OFFER_ANCHOR } from '../data/collection'
import { withUtmParams } from './checkoutUrl'

/** True only when a real https checkout destination has been configured. */
export function isCheckoutConfigured(): boolean {
  return /^https:\/\/\S+$/.test(CHECKOUT_URL)
}

/** Checkout URL with the visitor's UTMs, or the offer anchor until a checkout exists. */
export function getCheckoutHref(): string {
  return isCheckoutConfigured() ? withUtmParams(CHECKOUT_URL) : OFFER_ANCHOR
}

/** Shared click handler for every purchase button. */
export function handleCheckoutClick(event: React.MouseEvent<HTMLAnchorElement>): void {
  if (!isCheckoutConfigured()) return
  // Re-resolve at click time so the link always carries the visitor's UTMs.
  event.currentTarget.href = withUtmParams(CHECKOUT_URL)
}
